import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { 
    IClinicSubscription, 
    ICreateClinicSubscription, 
    IUpdateClinicSubscription,
    IClinicSeatUsage
} from '../../entities/clinicSubscription/ClinicSubscription.ts';

export class ClinicSubscriptionsApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/ClinicSubscriptions`;

    public static apiUrls: {
        createSubscription: string;
        updateSubscription: string;
        getSeatUsage: string;
        releaseSeat: string;
        deleteSubscription: string;
    } = {
        createSubscription: `${ClinicSubscriptionsApi.baseApiUrl}`,
        updateSubscription: `${ClinicSubscriptionsApi.baseApiUrl}/:subscriptionId`,
        getSeatUsage: `${ClinicSubscriptionsApi.baseApiUrl}/:clinicId/usage`,
        releaseSeat: `${ClinicSubscriptionsApi.baseApiUrl}/:clinicId/users/:userId`,
        deleteSubscription: `${ClinicSubscriptionsApi.baseApiUrl}/:subscriptionId`,
    };

    public static async createSubscription(data: ICreateClinicSubscription): Promise<IClinicSubscription> {
        return this.sendApiRequest<IClinicSubscription>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.createSubscription,
            data: data
        });
    }

    public static async updateSubscription(subscriptionId: string, data: IUpdateClinicSubscription): Promise<IClinicSubscription> {
        return this.sendApiRequest<IClinicSubscription>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.updateSubscription.replace(':subscriptionId', subscriptionId),
            data: data
        });
    }

    public static async getSeatUsage(clinicId: string): Promise<IClinicSeatUsage | undefined> {
        return this.sendApiRequest<IClinicSeatUsage>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getSeatUsage.replace(':clinicId', clinicId)
        });
    }

    public static async releaseSeat(clinicId: string, userId: string): Promise<{ message: string; clinicId: number; userId: string } | undefined> {
        return this.sendApiRequest<{ message: string; clinicId: number; userId: string }>({
            method: HttpMethodEnum.DELETE,
            path: this.apiUrls.releaseSeat.replace(':clinicId', clinicId).replace(':userId', userId)
        });
    }

    public static async deleteSubscription(subscriptionId: string): Promise<{ message: string; subscriptionId: number } | undefined> {
        return this.sendApiRequest<{ message: string; subscriptionId: number }>({
            method: HttpMethodEnum.DELETE,
            path: this.apiUrls.deleteSubscription.replace(':subscriptionId', subscriptionId)
        });
    }
} 